import React from "react";
import { useSelector } from "react-redux";
import style from './DQC.module.scss';

const DQCPage = (props: any) => {
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);

  return (
    <section className={style.dqc_container}>
      <h2 className={style.page_main_heading}>{pageDetails?.name}</h2>
      <div className={style.table_wrapper}>
        <table className={style.dqc_table}>
          <thead>
            <tr>
              <th className={style.table_header_small}>Category</th>
              <th className={style.table_header_large}>DQC Error</th>
              <th className={style.table_header_large}>Comment</th>
            </tr>
          </thead>
          <tbody>
            {pageDetails?.dqcComments &&
              pageDetails.dqcComments.map((dqcErrorItem: any, index: number) => (
                <tr key={index}>
                  <td className={style.table_cell_small}>{dqcErrorItem.category}</td>
                  <td className={style.table_cell_large}>{dqcErrorItem.designErrorText}</td>
                  <td className={style.table_cell_large}>{dqcErrorItem.exceptionReasoning}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default DQCPage;